var alignment_rtlignore_default = {
  "alignLeft": "QueVW",
  "textWrapNowrap": "-eqba",
  "alignRight": "McnQU",
  "alignCenter": "e0q-e",
  "sizeFullWidth": "_3jJhk",
  "renderedInTable": "_5VwDr",
  "sizeOriginal": "E70-F",
  "sizeContent": "mB5A7",
  "sizeSmall": "rchoH",
  "sizeSmallCenter": "hrpMP",
  "flex": "l1R1Z",
  "LEFT": "UT8tn",
  "CENTER": "BrMQC",
  "RIGHT": "MIM-1",
  "AUTO": "z3yvg",
  "JUSTIFY": "ZJ2Pl"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
